/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesBatchStatus } from './WebApiModelsEnumerationTypesBatchStatus';
import {
    WebApiModelsEnumerationTypesBatchStatusFromJSON,
    WebApiModelsEnumerationTypesBatchStatusFromJSONTyped,
    WebApiModelsEnumerationTypesBatchStatusToJSON,
} from './WebApiModelsEnumerationTypesBatchStatus';
import type { WebApiModelsEnumerationTypesJobType } from './WebApiModelsEnumerationTypesJobType';
import {
    WebApiModelsEnumerationTypesJobTypeFromJSON,
    WebApiModelsEnumerationTypesJobTypeFromJSONTyped,
    WebApiModelsEnumerationTypesJobTypeToJSON,
} from './WebApiModelsEnumerationTypesJobType';

/**
 * DTO for batch job result
 * @export
 * @interface WebApiBatchJobDtoBatchJobDto
 */
export interface WebApiBatchJobDtoBatchJobDto {
    /**
     * Gets or sets the identifier.
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    id?: number;
    /**
     * Gets or sets the request identifier for correlation.
     * @type {string}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    requestId?: string;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesJobType}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    jobType?: WebApiModelsEnumerationTypesJobType;
    /**
     * Gets or sets the parameters as JSON.
     * @type {string}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    parametersJson?: string | null;
    /**
     * Gets or sets the created at timestamp.
     * @type {Date}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    createdAt?: Date;
    /**
     * Gets or sets the started at timestamp.
     * @type {Date}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    startedAt?: Date | null;
    /**
     * Gets or sets the completed at timestamp.
     * @type {Date}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    completedAt?: Date | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesBatchStatus}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    status?: WebApiModelsEnumerationTypesBatchStatus;
    /**
     * Gets or sets the error message.
     * @type {string}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    errorMessage?: string | null;
    /**
     * Gets or sets the company identifier.
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobDto
     */
    companyId?: number;
}

/**
 * Check if a given object implements the WebApiBatchJobDtoBatchJobDto interface.
 */
export function instanceOfWebApiBatchJobDtoBatchJobDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiBatchJobDtoBatchJobDtoFromJSON(json: any): WebApiBatchJobDtoBatchJobDto {
    return WebApiBatchJobDtoBatchJobDtoFromJSONTyped(json, false);
}

export function WebApiBatchJobDtoBatchJobDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiBatchJobDtoBatchJobDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'jobType': !exists(json, 'jobType') ? undefined : WebApiModelsEnumerationTypesJobTypeFromJSON(json['jobType']),
        'parametersJson': !exists(json, 'parametersJson') ? undefined : json['parametersJson'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'startedAt': !exists(json, 'startedAt') ? undefined : (json['startedAt'] === null ? null : new Date(json['startedAt'])),
        'completedAt': !exists(json, 'completedAt') ? undefined : (json['completedAt'] === null ? null : new Date(json['completedAt'])),
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesBatchStatusFromJSON(json['status']),
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
    };
}

export function WebApiBatchJobDtoBatchJobDtoToJSON(value?: WebApiBatchJobDtoBatchJobDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'requestId': value.requestId,
        'jobType': WebApiModelsEnumerationTypesJobTypeToJSON(value.jobType),
        'parametersJson': value.parametersJson,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'startedAt': value.startedAt === undefined ? undefined : (value.startedAt === null ? null : value.startedAt.toISOString()),
        'completedAt': value.completedAt === undefined ? undefined : (value.completedAt === null ? null : value.completedAt.toISOString()),
        'status': WebApiModelsEnumerationTypesBatchStatusToJSON(value.status),
        'errorMessage': value.errorMessage,
        'companyId': value.companyId,
    };
}

